import Smenus from "./Smenus";
export default Smenus;
